(function (window, document) {
  'use strict';
  if (window.CPGrowth) return;
  var strings = {};
  try { strings = JSON.parse(document.querySelector('[data-cp-growth-strings]').textContent); } catch (_) {}
  function text(key, fallback) { return strings[key] || fallback; }
  function announce(node, message) { if (node) node.textContent = message; }
  function pairInit(root) {
    root.querySelectorAll('[data-cp-pair]').forEach(function (pair) {
      var button = pair.querySelector('[data-cp-pair-add]');
      if (!button || pair.dataset.cpGrowthReady || !window.CPCartBridge) return;
      var ids = [button.dataset.first, button.dataset.second];
      if (ids[0] === ids[1] || ids.some(function (id) { return !/^[1-9]\d*$/.test(id || ''); })) return;
      pair.dataset.cpGrowthReady = '1'; button.hidden = false;
      var status = pair.querySelector('[data-cp-pair-status]');
      var cart = pair.querySelector('[data-cp-pair-cart]');
      button.addEventListener('click', async function () {
        if (button.disabled || pair.dataset.cpPairAttempted) return;
        pair.dataset.cpPairAttempted = '1'; button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        announce(status, text('adding', 'Adding your selected products…'));
        try {
          var result = await window.CPCartBridge.addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }), { source: 'cp-curated-pair', activeElement: button });
          if (!result || !Array.isArray(result.added) || !Array.isArray(result.failed)) throw new Error('Unconfirmed basket response');
          if (result.failed.length) {
            announce(status, text('partial', 'Some products were added, but not the complete pair. Check your basket before adding anything else.'));
            button.textContent = text('review', 'Review your basket');
          } else {
            announce(status, text('added', 'One of each has been added. Review your basket before checkout.'));
            button.textContent = text('addedLabel', 'Added to basket');
          }
        } catch (_) {
          announce(status, text('failed', 'The complete pair could not be confirmed. Check your basket before trying again, or open each product above.'));
          button.textContent = text('review', 'Review your basket');
        } finally {
          button.removeAttribute('aria-busy');
          if (cart) { cart.hidden = false; cart.focus({ preventScroll: true }); }
        }
      });
    });
  }
  function localDate(date) {
    return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
  }
  function escapeICS(value) { return String(value || '').replace(/\\/g, '\\\\').replace(/\r\n|\n|\r/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,'); }
  function foldLine(line) {
    var lines = [], current = '', bytes = 0;
    Array.from(line).forEach(function (char) {
      var size = new TextEncoder().encode(char).length;
      if (bytes + size > 73) { lines.push(current); current = ' '; bytes = 1; }
      current += char; bytes += size;
    });
    lines.push(current); return lines.join('\r\n');
  }
  function calendarFile(title, date, url) {
    var link = new URL(url);
    if (!/^https?:$/.test(link.protocol) || /[\r\n]/.test(url)) throw new Error('Invalid calendar URL');
    url = link.href;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new Error('Invalid date');
    var day = new Date(date + 'T12:00:00');
    if (!Number.isFinite(day.getTime()) || localDate(day) !== date) throw new Error('Invalid date');
    var next = new Date(day); next.setDate(next.getDate() + 1);
    var id = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    var stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
    var description = text('calendarBody', 'Check your supplies and review the current product before ordering. This is not an automatic order or subscription.') + '\n' + url;
    return ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Cafe Perfection//Customer reorder reminder//EN','CALSCALE:GREGORIAN','METHOD:PUBLISH','BEGIN:VEVENT','UID:' + id + '@cafeperfection.com','DTSTAMP:' + stamp,'DTSTART;VALUE=DATE:' + date.replace(/-/g, ''),'DTEND;VALUE=DATE:' + localDate(next).replace(/-/g, ''),'SUMMARY:' + escapeICS(text('calendarTitle', 'Review supplies: ') + title),'DESCRIPTION:' + escapeICS(description),'URL:' + url,'TRANSP:TRANSPARENT','END:VEVENT','END:VCALENDAR'].map(foldLine).join('\r\n') + '\r\n';
  }
  function reminderInit(root) {
    root.querySelectorAll('[data-cp-reminder]').forEach(function (details) {
      if (details.dataset.cpGrowthReady) return;
      details.dataset.cpGrowthReady = '1'; details.hidden = false;
      var date = details.querySelector('[data-cp-reminder-date]');
      var button = details.querySelector('[data-cp-reminder-create]');
      var status = details.querySelector('[data-cp-reminder-status]');
      if (!date || !button) return;
      date.min = localDate(new Date()); var due = new Date(); due.setDate(due.getDate() + 28); date.value = localDate(due);
      button.addEventListener('click', function () {
        if (!date.checkValidity() || !date.value) { date.reportValidity(); announce(status, text('invalidDate', 'Choose today or a future date.')); return; }
        try {
          var url = new URL(details.dataset.productUrl, window.location.origin);
          if (url.origin !== window.location.origin) throw new Error('Unexpected product URL');
          url.search = ''; url.hash = '';
          var productRoot = details.closest('[data-cp-product]');
          var variant = productRoot && productRoot.querySelector('form.cp-product__form [name="id"]');
          if (variant && /^[1-9]\d*$/.test(variant.value)) url.searchParams.set('variant', variant.value);
          var data = calendarFile(details.dataset.title, date.value, url.href);
          var blobUrl = URL.createObjectURL(new Blob([data], { type: 'text/calendar;charset=utf-8' }));
          var link = document.createElement('a'); link.href = blobUrl; link.download = 'cafe-perfection-reorder-' + date.value + '.ics';
          document.body.appendChild(link); link.click(); link.remove();
          window.setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 30000);
          announce(status, text('calendarDone', 'Calendar file created. Import it into your calendar to save the reminder.'));
        } catch (_) { announce(status, text('calendarFailed', 'The calendar file could not be created. Add a reminder in your calendar manually.')); }
      });
    });
  }
  function mobileInit(root) {
    root.querySelectorAll('[data-cp-mobile-action]').forEach(function (bar) {
      if (bar.dataset.cpGrowthReady || !('IntersectionObserver' in window)) return;
      var product = bar.closest('[data-cp-product]');
      if (!product) return;
      var target = product.querySelector('form.cp-product__form') || product.querySelector('.cp-product__commercial-primary');
      if (!target) return;
      bar.dataset.cpGrowthReady = '1';
      var mq = window.matchMedia('(max-width: 749px)'), passed = false;
      var returnButton = bar.querySelector('[data-cp-return-to-buy]');
      function update() {
        var overlay = document.querySelector('dialog[open], cart-drawer.active, .drawer.active, menu-drawer details[open], #shopify-pc__banner');
        var blocked = !!(overlay && overlay.getClientRects().length);
        var visible = mq.matches && passed && !blocked;
        if (bar.hidden === visible) bar.hidden = !visible;
        if (product.classList.contains('cp-growth-has-mobile-action') !== visible) product.classList.toggle('cp-growth-has-mobile-action', visible);
      }
      var observer = new IntersectionObserver(function (entries) {
        passed = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0; update();
      });
      observer.observe(target);
      mq.addEventListener('change', update);
      var frame = 0;
      var mutations = new MutationObserver(function () {
        if (frame) return;
        frame = requestAnimationFrame(function () { frame = 0; update(); });
      });
      mutations.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class', 'style', 'hidden'] });
      if (returnButton) returnButton.addEventListener('click', function () {
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        var input = target.querySelector('select:not([disabled]), input[name="quantity"], button:not([disabled])');
        if (input) input.focus({ preventScroll: true });
      });
      product.addEventListener('cp:variant:change', function () {
        var add = target.querySelector('[data-cp-add-button]');
        if (returnButton) returnButton.textContent = add && add.disabled ? text('viewOptions', 'View options') : text('chooseBuy', 'Choose & buy');
      });
      document.addEventListener('shopify:section:unload', function dispose(e) {
        if (!e.target.contains(product)) return;
        observer.disconnect(); mutations.disconnect(); mq.removeEventListener('change', update);
        document.removeEventListener('shopify:section:unload', dispose);
      });
    });
  }
  function leadInit(root) {
    root.querySelectorAll('[data-cp-lead-details]').forEach(function (details) {
      if (details.dataset.cpGrowthReady) return;
      details.dataset.cpGrowthReady = '1';
      var select = details.closest('form') && details.closest('form').querySelector('[data-contact-intent]');
      if (!select) return;
      var contact = details.closest('[data-cp-contact-v14]');
      function update() {
        var hide = /fault|existing customer|documents|ingredients|home order/i.test(select.value) || /^home-/.test(contact && contact.dataset.contactIntent || '');
        details.hidden = hide;
        details.querySelectorAll('input,select').forEach(function (input) { input.disabled = hide; });
      }
      select.addEventListener('change', update);
      if (contact) contact.addEventListener('click', function (e) { if (e.target.closest('[data-contact-route-link]')) update(); });
      update();
    });
  }
  function init(root) { pairInit(root); reminderInit(root); mobileInit(root); leadInit(root); }
  window.CPGrowth = { init: init, calendarFile: calendarFile };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true }); else init(document);
  window.addEventListener('load', function () { init(document); }, { once: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})(window, document);
